// extracted by mini-css-extract-plugin
export default {"h1":"SectionHeader_h1__CZsBa","h2":"SectionHeader_h2__mSJGz","header":"SectionHeader_header__634Mm","actions":"SectionHeader_actions__OGath"};